import React from 'react'
import styles from './Goods.module.css'

export default function Goods() {
    return (
        <div className={styles.container}>
            <div className={styles.layout}>
                <div className={styles.wrapper}>
                    <h1 className="title">
                        <span className="underline">Таны бизнест оруулах хувь нэмэр </span>
                    </h1>
                    <ul>
                        <li>
                            Эрчим хүчний суурь нөхцөл байдлыг тодорхойлно
                        </li>
                        <li>
                            Эрчим хүчний анхан шатны статистик мэдээлэл боловсруулна
                        </li>
                        <li>
                            Хэмжилт, тооцоо хийнэ
                        </li>
                        <li>
                            Одоогийн нөхцөл байдалд дүн шинжилгээ хийж дүгнэлт гаргана
                        </li>
                        <li>
                            Эрчим хүчний үр ашгийг дээшлүүлэх гарцуудыг тодорхойлж зөвлөмж өгнө
                        </li>
                        <li>
                            Нарийвчилсан аудит хийх чиглэлийг тодорхойлно
                        </li>
                        <li>
                            Шаардлагатай хөрөнгө оруулалт, эдийн засгийн үр ашгийг тодорхойлно
                        </li>
                        <li>
                            Аудитын нэгдсэн тайлан боловсруулж хүлээлгэн өгнө
                        </li>
                        <li>
                            Эрчим хүчний үр ашгийг дээшлүүлэх төлөвлөгөө боловсруулна
                        </li>
                        <li>
                            Хэмнэх эрчим хүч, бууруулах CO<sub style={{color: '#fff'}}>2</sub>-г тодорхойлно
                        </li>
                        <li>
                            Сургалт зохион байгуулна  
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
